(() => {
  if (window.nwanPartLinksLoaded) return;
  window.nwanPartLinksLoaded = true;

  const parameter = 'filter.p.product_type';
  const key = value => value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const groups = [
    ['Front Splitters & Canards', ['Front Splitters', 'Front Canards']],
    ['Spoilers & Rear Styling', ['Rear Spoilers', 'Rear Bumper Winglets', 'Window Louvers']],
    ['Grilles & Exterior Trims', ['Air Vent Trims', 'Fog Light Trims', 'Fender Vent Trims', 'Bumper Trims', 'Grilles', 'Exhaust Trims']],
    ['Headlight Trims', ['Headlight Eyebrows', 'Headlight Trims']],
    ['Mirror & Interior Trims', ['Mirror Trims', 'Interior Trims', 'Rain Eyebrow']],
    ['Repair & Maintenance', ['Sunroof Repair Kits', 'Water Pumps']],
    ['Covers & Fixings', ['Car Cover Straps', 'Clips & Fasteners']],
  ];
  const groupByType = new Map(groups.flatMap(([label, types]) => types.map(type => [key(type), key(label)])));
  const requests = new Map();

  async function loadOptions(catalogUrl) {
    const url = new URL(catalogUrl, window.location.origin);
    if (url.origin !== window.location.origin) return [];
    // Unfiltered collection context supplies all native group values, even on the homepage.
    url.search = '';
    url.hash = '';
    url.searchParams.set('section_id', 'nwan-shop-filter-options');
    const response = await fetch(url.href, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Category options unavailable');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    return Array.from(html.querySelectorAll('[data-independent-filter-options] input[name="filter.p.product_type"]')).map(input => ({
      label: key(input.closest('label').querySelector('span').textContent.trim()),
      value: input.value,
    }));
  }

  async function initialize(section) {
    if (section.dataset.partLinksInitialized) return;
    section.dataset.partLinksInitialized = 'true';
    const catalogUrl = section.dataset.catalogUrl;
    if (!catalogUrl || !section.querySelector('[data-auto-part-link]')) return;
    if (!requests.has(catalogUrl)) {
      requests.set(catalogUrl, loadOptions(catalogUrl).catch(() => {
        requests.delete(catalogUrl);
        return [];
      }));
    }
    const options = await requests.get(catalogUrl);
    if (!options.length) return;
    section.querySelectorAll('[data-auto-part-link]').forEach(link => {
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      const originalValues = url.searchParams.getAll(parameter);
      if (!originalValues.length) return;
      const values = originalValues.map(value => {
        const direct = options.find(option => option.value === value || option.label === key(value));
        const grouped = options.find(option => option.label === groupByType.get(key(value)));
        return (direct || grouped)?.value || value;
      });
      url.searchParams.delete(parameter);
      new Set(values).forEach(value => url.searchParams.append(parameter, value));
      link.href = url.pathname + url.search + url.hash;
    });
  }

  function initializeAll() {
    document.querySelectorAll('[data-nwan-part-links]').forEach(section => {
      initialize(section).catch(() => {}); // Existing hrefs remain usable on any enhancement failure.
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
